import { makeStyles } from '@material-ui/core';
import { calculateWidth, rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

const MENU_FOOTER_SPACING = 1.46;

export const styles = makeStyles(theme => ({
  menuBottomRowContainer: {
    padding: `0 ${MENU_FOOTER_SPACING / 2}vw ${MENU_FOOTER_SPACING}vw`,
  },
  buttonContainer: {
    margin: `0 ${MENU_FOOTER_SPACING / 2}vw`,
  },
  buttonIcon: {
    // The button has an interior padding of 8 by default, so subtract 8
    padding: `0 ${calculateWidth(21 - 8).stringValue}`,
    [theme.breakpoints.down('md')]: {
      padding: '0 0.73vw 0 0.29vw',
      marginRight: 3,
    },
    '& > *:first-child': {
      fontSize: vh(3.12),
    },
  },
  buttonLabel: {
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: 0.89,
    letterSpacing: '0.5px',
    padding: '0 0.117vw 0 0.156vw',
    [theme.breakpoints.down('md')]: {
      fontSize: rem(1),
      lineHeight: 1.1,
    },
  },
  hideButton: {
    boxShadow: `0 1px 4px 0 ${themeColor.semitransparentblack}`,
  },
}));
